import PropTypes from 'prop-types';

// material-ui
import Chip from '@mui/material/Chip';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

// project imports
import MainCard from 'components/MainCard';

// assets
import RiseOutlined from '@ant-design/icons/RiseOutlined';
import FallOutlined from '@ant-design/icons/FallOutlined';

const iconSX = { fontSize: '0.75rem', color: 'inherit', marginLeft: 0, marginRight: 0 };

function statusColor(s) {
  const k = String(s).toLowerCase();
  if (k === 'read' || k === 'delivered' || k === 'sent') return 'success';
  if (k === 'failed') return 'error';
  if (k === 'pending') return 'warning';
  return 'primary';
}

export default function AnalyticEcommerce({ color = 'primary', title, count, isLoss, extra, statusChips }) {
  return (
    <MainCard contentSX={{ p: 2.25 }}>
      <Stack sx={{ gap: 0.5 }}>
        <Typography variant="h6" color="text.secondary">
          {title}
        </Typography>

        <Grid container sx={{ alignItems: 'center', flexWrap: 'wrap' }}>
          <Grid>
            <Typography variant="h4">{count}</Typography>
          </Grid>

          <Grid>
            <Chip
              variant="combined"
              color={color}
              icon={isLoss ? <FallOutlined style={iconSX} /> : <RiseOutlined style={iconSX} />}
              sx={{ ml: 1.25, pl: 1 }}
              size="small"
            />
          </Grid>

          {/* ===== STATUS BOX WARNA DI SEBELAH ANGKA ===== */}
          {Array.isArray(statusChips) && statusChips.length > 0 && (
            <Grid sx={{ ml: 2 }}>
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                {statusChips.map((s) => (
                  <Chip key={s.status} label={`${s.status.toUpperCase()}:${s.value}`} size="small" color={statusColor(s.status)} />
                ))}
              </Box>
            </Grid>
          )}
        </Grid>
      </Stack>

      {extra ? (
        <Box sx={{ pt: 2.25 }}>
          <Typography variant="caption" color="text.secondary">
            {extra}
          </Typography>
        </Box>
      ) : null}
    </MainCard>
  );
}

AnalyticEcommerce.propTypes = {
  color: PropTypes.string,
  title: PropTypes.string,
  count: PropTypes.string,
  percentage: PropTypes.number,
  isLoss: PropTypes.bool,
  extra: PropTypes.string,
  statusChips: PropTypes.array
};
